export default __webpack_public_path__ + "static/parts-min-0215bfdb09e09098ca44f50e3e194a23.jpg";